module.exports = __webpack_public_path__ + "static/media/bglogin.7eb3f531.png";